import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Plus, CreditCard, ShieldCheck, ArrowUpRight, ArrowDownLeft, RefreshCcw } from 'lucide-react';
import { mockTransactions } from '../data/mockData';
export function WalletScreen() {
  const navigate = useNavigate();
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="flex flex-col min-h-screen bg-slate-50" data-id="element-1869">
      <div className="bg-blue-600 px-6 pt-12 pb-6 text-white sticky top-0 z-10 rounded-b-3xl shadow-md" data-id="element-1870">
        <div className="flex items-center gap-3 mb-6" data-id="element-1871">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 hover:bg-blue-700 rounded-full transition-colors" data-id="element-1872">
            <ArrowLeft className="w-6 h-6" data-id="element-1873" />
          </button>
          <h1 className="text-xl font-bold" data-id="element-1874">Wallet</h1>
        </div>

        <div className="text-center mb-6" data-id="element-1875">
          <p className="text-blue-200 text-sm mb-1" data-id="element-1876">Available Balance</p>
          <h2 className="text-4xl font-bold" data-id="element-1877">₦45,000</h2>
        </div>

        <div className="flex gap-3" data-id="element-1878">
          <button className="flex-1 bg-white text-blue-600 py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 shadow-sm hover:bg-blue-50 transition-colors" data-id="element-1879">
            <Plus className="w-4 h-4" data-id="element-1880" /> Add Money
          </button>
          <button className="flex-1 bg-blue-700 text-white py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 shadow-sm hover:bg-blue-800 transition-colors" data-id="element-1881">
            <CreditCard className="w-4 h-4" data-id="element-1882" /> Withdraw
          </button>
        </div>
      </div>

      <div className="p-6 flex-1 overflow-y-auto" data-id="element-1883">
        <div className="mb-8" data-id="element-1884">
          <h3 className="font-semibold text-slate-900 mb-4" data-id="element-1885">Quick Add</h3>
          <div className="flex gap-3" data-id="element-1886">
            {['5,000', '10,000', '20,000'].map(amount => <button key={amount} className="flex-1 py-2 bg-white border border-slate-200 rounded-xl text-sm font-medium text-slate-700 shadow-sm hover:border-blue-600 hover:text-blue-600 transition-colors" data-id="element-1887">
                ₦{amount}
              </button>)}
          </div>
        </div>

        <div className="mb-8" data-id="element-1888">
          <div className="flex items-center justify-between mb-4" data-id="element-1889">
            <h3 className="font-semibold text-slate-900" data-id="element-1890">Payment Methods</h3>
            <button className="text-sm text-blue-600 font-medium" data-id="element-1891">
              Add New
            </button>
          </div>
          <div className="space-y-3" data-id="element-1892">
            <div className="bg-white p-4 rounded-xl border border-slate-100 shadow-sm flex items-center justify-between" data-id="element-1893">
              <div className="flex items-center gap-3" data-id="element-1894">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center" data-id="element-1895">
                  <CreditCard className="w-5 h-5 text-slate-600" data-id="element-1896" />
                </div>
                <div data-id="element-1897">
                  <p className="font-medium text-slate-900" data-id="element-1898">•••• 4242</p>
                  <p className="text-xs text-slate-500" data-id="element-1899">Expires 12/25</p>
                </div>
              </div>
              <span className="text-xs font-medium bg-slate-100 text-slate-600 px-2 py-1 rounded-md" data-id="element-1900">
                Default
              </span>
            </div>

            <div className="bg-white p-4 rounded-xl border border-slate-100 shadow-sm flex items-center justify-between opacity-70" data-id="element-1901">
              <div className="flex items-center gap-3" data-id="element-1902">
                <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center" data-id="element-1903">
                  <ShieldCheck className="w-5 h-5 text-blue-600" data-id="element-1904" />
                </div>
                <div data-id="element-1905">
                  <p className="font-medium text-slate-900" data-id="element-1906">Health Insurance</p>
                  <p className="text-xs text-slate-500" data-id="element-1907">Connect HMO</p>
                </div>
              </div>
              <span className="text-[10px] font-bold uppercase tracking-wider bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full" data-id="element-1908">
                Coming Soon
              </span>
            </div>
          </div>
        </div>

        <div data-id="element-1909">
          <h3 className="font-semibold text-slate-900 mb-4" data-id="element-1910">
            Recent Transactions
          </h3>
          <div className="space-y-4" data-id="element-1911">
            {mockTransactions.map(tx => <div key={tx.id} className="flex items-center justify-between" data-id="element-1912">
                <div className="flex items-center gap-3" data-id="element-1913">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${tx.amount > 0 ? 'bg-green-100' : 'bg-slate-100'}`} data-id="element-1914">
                    {tx.status === 'refunded' ? <RefreshCcw className="w-4 h-4 text-slate-600" data-id="element-1915" /> : tx.amount > 0 ? <ArrowDownLeft className="w-5 h-5 text-green-600" data-id="element-1916" /> : <ArrowUpRight className="w-5 h-5 text-slate-600" data-id="element-1917" />}
                  </div>
                  <div data-id="element-1918">
                    <p className="font-medium text-slate-900 text-sm" data-id="element-1919">
                      {tx.description}
                    </p>
                    <p className="text-xs text-slate-500 mt-0.5" data-id="element-1920">{tx.date}</p>
                  </div>
                </div>
                <div className="text-right" data-id="element-1921">
                  <p className={`font-semibold text-sm ${tx.amount > 0 ? 'text-green-600' : 'text-slate-900'}`} data-id="element-1922">
                    {tx.amount > 0 ? '+' : ''}₦
                    {Math.abs(tx.amount).toLocaleString()}
                  </p>
                  {tx.status === 'refunded' && <span className="text-[10px] text-slate-500 uppercase tracking-wider" data-id="element-1923">
                      Refunded
                    </span>}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </motion.div>;
}